"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderWithRouter = void 0;
var react_1 = require("@testing-library/react");
var react_router_dom_1 = require("react-router-dom");
var renderWithRouter = function (ui, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.route, route = _c === void 0 ? '/' : _c;
    window.history.pushState({}, 'Test page', route);
    // @ts-ignore
    return (0, react_1.render)(ui, { wrapper: react_router_dom_1.MemoryRouter });
};
exports.renderWithRouter = renderWithRouter;
